<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">分销佣金比例设置</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      分销佣金比例设置以及明细
      <small>分销佣金比例设置以及明细...</small>
    </h1>
    <!-- end page-header -->
    <panel title="分销佣金比例设置">
      <div class="row content">
        <div class="col-md-4">
          <Card :bordered="false">
            <p slot="title">分销佣金比例设置</p>
            <commissionconfig></commissionconfig>
          </Card>
        </div>
        <div class="col-md-8">
          <Card :bordered="false">
            <p slot="title">佣金获取明细</p>
            <Row :gutter="2">
              <Col span="6">
                <Input v-model="filterCond.username" placeholder="用户名称" />
              </Col>
              <Col span="6">
                <DatePicker v-model="begindate" placeholder="开始时间"></DatePicker>
              </Col>
              <Col span="6">
                <DatePicker v-model="enddate" placeholder="结束日期"></DatePicker>
              </Col>
              <Col span="6">
                <button type="button" class="btn btn-theme" @click="fn_query()">查询</button>
              </Col>
            </Row>
            <Table size="small" class="m-t-10" :columns="columns" :data="data">
              <template slot-scope="{row}" slot="commissiontype">
                <span v-if="row.commissiontype == 'user'">新用户</span>
                <span v-else-if="row.commissiontype == 'order'">订单</span>
              </template>
            </Table>
            <Page
              style="margin-top:10px"
              :total="totalRows"
              :current="filterCond.page"
              :page-size="filterCond.pageNum"
              show-total
              show-elevator
              @on-change="fn_switchPage"
            />
          </Card>
        </div>
      </div>
    </panel>
  </div>
</template>
<script>
import commissionconfig from "./commissionconfig";
import { getCommissionList } from "@/api/commission";
import moment from "moment";
export default {
  components: { commissionconfig },
  data() {
    return {
      columns: [
        {
          title: "时间",
          key: "created_at",
          width: 150
        },
        {
          title: "人员",
          key: "username",
          width: 150
        },
        {
          title: "佣金类型",
          slot: "commissiontype",
          width: 150
        },
        {
          title: "佣金金额",
          key: "commission",
          width: 150
        },
        {
          title: "其他信息",
          key: "remarks"
        }
      ],
      data: [],
      begindate: "",
      enddate: "",
      filterCond: {
        username: "",
        begindate: "",
        enddate: "",
        page: 1,
        pageNum: 15
      },
      totalRows: 0
    };
  },
  mounted() {
    this.fn_load(this.filterCond);
  },
  methods: {
    fn_query() {
      this.filterCond.page = 1;
      this.fn_load(this.filterCond);
    },
    fn_load(filterCond) {
      if (this.begindate) {
        filterCond.begindate = moment(this.begindate).format("YYYY-MM-DD");
      } else {
        filterCond.begindate = "";
      }
      if (this.enddate) {
        filterCond.enddate = moment(this.enddate).format("YYYY-MM-DD");
      } else {
        filterCond.enddate = "";
      }
      getCommissionList(filterCond)
        .then(res => {
          this.totalRows = res.data.total;
          this.data = res.data.data;
        })
        .catch(error => {
          this.$Message.error("错误" + error);
        });
    },
    fn_switchPage(page) {
      this.filterCond.page = page;
      this.fn_load(this.filterCond);
    }
  }
};
</script>